import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum OrganizationMemberAccessLogColumn {
    MEMBER = "member",
    CLIENT = "client",
    SOURCE = "source",
    CREATED_AT = "createdAt",
}

const MemberColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationMemberAccessLogColumn.MEMBER),
});
const ClientColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationMemberAccessLogColumn.CLIENT),
});
const SourceColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationMemberAccessLogColumn.SOURCE),
});
const CreatedAtColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationMemberAccessLogColumn.CREATED_AT),
});

export const OrganizationMemberAccessLogViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ORGANIZATION_MEMBER_ACCESS_LOG),
    columns: z.array(
        z.discriminatedUnion("id", [
            MemberColumnSchema,
            ClientColumnSchema,
            SourceColumnSchema,
            CreatedAtColumnSchema,
        ]),
    ),
});

export type OrganizationMemberAccessLogView = z.infer<
    typeof OrganizationMemberAccessLogViewSchema
>;
